import CoreApi from '@/api/CoreApi';
import type RobFlowVariables from '@/models/RobFlow';

export default async function loadRobotRobFlowVariables(
  serialNumber: string,
): Promise<RobFlowVariables> {
  try {
    const response = await CoreApi.axiosClient.get(
      `/variables/robflow/${serialNumber}`,
    );
    return response.data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error(error.response.data.detail);
    throw new Error(error.response.data.detail);
  }
}
